import { type DefaultOptions, QueryClient } from '@tanstack/react-query'

type QueryDefaults = NonNullable<DefaultOptions['queries']>

/**
 * A query client with the app's defaults. `main.tsx` builds the one the app runs on; the test
 * harness builds one per test from the same defaults, with `retry` turned off so a stubbed
 * failure is reported once rather than after a back-off.
 *
 * Queries are `offlineFirst`: offline, a query still makes its one request, which the service
 * worker answers from what was last loaded (features/pwa), rather than waiting for a network.
 */
export function createQueryClient(overrides: QueryDefaults = {}): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        gcTime: 5 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
        networkMode: 'offlineFirst',
        ...overrides,
      },
    },
  })
}

export const queryClient = createQueryClient()
